import backofficeService from '../../api/backoffice'

export default {
  /**
   * 🔹 Get all users (admin or organization-level)
   * @param {*} params
   * @returns {Promise<Object>}
   */
  getAll(params = {}) {
    return backofficeService
      .Api()
      .get('user', { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Get a specific user by ID
   * @param {Number} id
   * @param {*} params
   */
  getById(id, params = {}) {
    return backofficeService
      .Api()
      .get(`user/${id}`, { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Create a new user (registration)
   * @param {Object} data
   */
  create(data) {
    return backofficeService
      .Api()
      .post('user', data)
      .then(response => response.data)
      .catch(error => { throw error })
  },

  // 🟢 Save or update matchmaking preferences
  saveSearchPreferences(data) {
    const { UserId } = data;
    if (!UserId) throw new Error("UserId is required to save preferences.");

    // PUT /userSearchPreference/:userId
    return backofficeService
      .Api()
      .put(`userSearchPreference/${UserId}`, data)
      .then((res) => res.data)
      .catch((err) => {
        console.error("❌ saveSearchPreferences error:", err);
        throw err;
      });
  },

  // 🟢 Get preferences for current user
  getSearchPreferences(userId) {
    return backofficeService
      .Api()
      .get(`userSearchPreference/${userId}`)
      .then((res) => res.data)
      .catch((err) => {
        console.error("❌ getSearchPreferences error:", err);
        throw err;
      });
  },

  /**
   * 🔹 Update existing user
   * @param {Number} id
   * @param {Object} data
   */
  update(id, data) {
    return backofficeService
      .Api()
      .put(`user/${id}`, data)
      .then(response => response.data)
      .catch(error => { throw error })
  },

  submitFeedback(data) {
    return backofficeService
      .Api()
      .post("feedback", data)
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  /**
   * 🔹 Delete a user by ID
   * @param {Number} id
   * @param {*} params
   */
  delete(id, params = {}) {
    return backofficeService
      .Api()
      .delete(`user/${id}`, { params })
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Get the currently logged-in user
   * (requires backend auth middleware)
   */
  getCurrent() {
    return backofficeService
      .Api()
      .get('user/current')
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Get all profiles created by this user
   * @param {Number} userId
   */
  getProfilesByUser(userId) {
    return backofficeService
      .Api()
      .get(`user/${userId}/profiles`)
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Change user password (self)
   * @param {Number} id
   * @param {{ oldPassword: string, newPassword: string }} data
   */
  changePassword(id, data) {
    return backofficeService
      .Api()
      .put(`user/changePassword/${id}`, data)
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Forgot password — sends reset link to email
   * @param {{ email: string }} data
   */
  forgotPassword(data) {
    return backofficeService
      .Api()
      .post('user/forgotPassword', data)
      .then(response => response.data)
      .catch(error => { throw error })
  },

  /**
   * 🔹 Reset password (from reset link token)
   * @param {{ resetToken: string, password: string }} data
   */
  resetPassword(data) {
    return backofficeService
      .Api()
      .post('user/resetPassword', data)
      .then(response => response.data)
      .catch(error => { throw error })
  },
}